export const limitNumberToTwoDigits = (
  number: number | undefined | null
): number | undefined | null => {
  if (number === undefined || number === null) {
    return number; // Return undefined or null directly
  }

  const re = number?.toString().match(/^-?\d+(?:\.\d{0,2})?/);
  return re ? parseFloat(re[0]) : number;
};

export const toNumber = (value: unknown) => {
  return typeof value === 'number'
    ? value
    : value === ''
    ? null
    : typeof value === 'string'
    ? Number(value.replace(/,/gm, ''))
    : null;
};
